export default "__VITE_ASSET__ffdfb9d6__"